import React, { useState, useRef } from 'react';
import { Button, Input } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import './aiCrew.css';

/**
 * ChatComposer - the follow-up box under every reply, so the next request is typed, not clicked into.
 * It only hands the text to onAsk (a fresh analyze); it never changes data itself.
 */
export default function ChatComposer({ onAsk, maxLength = 500, placeholder = 'Ask a follow-up, e.g. who is in another crew, or add someone to a crew' }) {
  const [draft, setDraft] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);
  const sendingRef = useRef(false);

  const send = async () => {
    const text = draft.trim();
    if (!text || !onAsk || sendingRef.current) return;
    sendingRef.current = true; setSending(true); setError(null);
    try { await onAsk(text); setDraft(''); }
    catch { setError('Your request could not be sent. Your text is still here; please try again.'); }
    finally { sendingRef.current = false; setSending(false); }
  };

  return (
    <div className="ai-crew-answer-composer" data-testid="ai-crew-answer-composer">
      <Input.TextArea
        aria-label="Crew Call follow-up"
        disabled={sending}
        autoFocus
        autoSize={{ minRows: 1, maxRows: 4 }}
        maxLength={maxLength}
        value={draft}
        placeholder={placeholder}
        onChange={(e) => setDraft(e.target.value)}
        onPressEnter={(e) => { if (!e.shiftKey && !e.isComposing && !e.nativeEvent?.isComposing && e.keyCode !== 229) { e.preventDefault(); send(); } }}
      />
      <Button type="primary" shape="circle" icon={<SendOutlined />} aria-label="Send" onClick={send} loading={sending} disabled={!draft.trim() || sending} />
      {error && <p role="alert">{error}</p>}
    </div>
  );
}
